export enum FontType {
  CUSTOM = 'custom',
  GOOGLE = 'google'
}